<template>
  <iRow>
    <iMenu
      orientation="vertical"
      :active-item="activeItem"
      :items="parsedCommunityNav"
      :menu-item-style-overrides="myStyleOverrides"
    />
  </iRow>
</template>

<script>
import { SIDE_NAV_COMMUNITY, SIDE_NAV_STYLE_OVERRIDES } from "@/constants/nav-constants";
import { parseUrlVars } from "@/helpers/parseUrlVars";
import { filterMenuItems } from "@/helpers/capabilities-helper";
import { useGeneralStore } from "%/stores/general-store";
import { mapState } from "pinia";

export default {
  name: "CommunitySideNav",
  props: {
    activeItem: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapState(useGeneralStore, [
      "orgId",
    ]),
    myStyleOverrides() {
      return SIDE_NAV_STYLE_OVERRIDES;
    },
    parsedCommunityNav() {
      const filteredMenuItems = filterMenuItems(SIDE_NAV_COMMUNITY);
      return parseUrlVars(filteredMenuItems, { "{org_id}": this.orgId });
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.text-link) {
  padding-top: 6px;
  padding-bottom: 6px;
}
</style>
